import { GLOBAL_ERROR } from "redux/constants"

export const setError = (error) => ({
    type: GLOBAL_ERROR.ERROR_HANDLING,
    error
});